import Header from "../components/Header";
import MobileBottomNav from "../pages/MobileBottomNav";
import { Outlet } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";

export default function MainLayout() {
  const { user } = useContext(AuthContext) || {};

  return (
    <>
      <Header />
      <div className="mt-20 min-h-screen pb-[calc(4rem+env(safe-area-inset-bottom))] md:pb-0">
        <Outlet />
      </div>
      <MobileBottomNav isLoggedIn={!!user} />
    </>
  );
}
